// extracted by mini-css-extract-plugin
module.exports = {"text":"MenuEditMerch_text__lxxGY","menuArea":"MenuEditMerch_menuArea__kUJGe","menuItem":"MenuEditMerch_menuItem__I9RWa","iconContainer":"MenuEditMerch_iconContainer__L7I_c"};